export default __webpack_public_path__ + "static/media/warning--loop-270-degree--g1.2e953561.png";